import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { tokenSignIn } from "../../api/auth";
import { FullPageSpinner } from "../shared/full-page-spinner";
import { Alert } from "@mui/material";
import { UserProgramContext } from "../../context/user-program/user-program";

// @TODO - check if user already signed in
export const MagicLink = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const userId = params.get("userId");

  const navigate = useNavigate();
  const [error, setError] = useState<string>("");

  const { fetchProgram } = useContext(UserProgramContext);

  useEffect(() => {
    if (!token || !userId) {
      setError("Invalid Link");
      return;
    }

    tokenSignIn({ token, userId })
      .then(() => fetchProgram())
      .then(() => {
        navigate("/");
      })
      .catch(() => {
        navigate("/sign-in");
      });
  }, [navigate, token, userId, fetchProgram]);

  if (!token || !userId) {
    navigate("/");
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return <FullPageSpinner />;
};
